<template lang="pug">
  main.main.main__where-to-get
    .main__header
      h1.main__title {{ $t('whereToGet.title') }}
      h2.main__subtitle {{ $t('whereToGet.warning') }}
    .main__container
      .main__content
        form.form.form_where-to-get(@submit.prevent="submitForm")
          .form__row
            label.form__label {{ $t('whereDelivery.labels.region') }}
            .form__field.form__field_row
              .radio.radio_region(:key="index" v-for="(item, key, index) in $t('whereToGet.regionCheckbox')")
                input.radio__input(
                type="radio"
                :id="'radioRegion' + index"
                :value="key"
                name="region"
                v-model="region")
                label.radio__label(
                :for="'radioRegion' + index") {{ item }}
          template(v-if="region === 'kiev'") <!--if choose kiev-->
            .form__row
              label.form__label {{ $t('whereDelivery.labels.street') }}
              input.form__input(
              type='text'
              v-model="$v.street.$model"
              )
            .form__row.form__row_row.form__row-address
              .form__field.form__field_column
                label.form__label {{ $t('whereDelivery.labels.home') }}
                input.form__input.form__input_small(
                type='text'
                v-model="$v.home.$model"
                )
              .form__field.form__field_column
                label.form__label {{ $t('whereDelivery.labels.room') }}
                input.form__input.form__input_small(
                type='text'
                v-model="room"
                )
            .form__row
              .checkbox.checkbox_return.form__checkbox-return
                input.checkbox__input(id="delivery" type="checkbox" checked v-model="delivery")
                label.checkbox__label(for="delivery") {{ $t('service-request.labels.checkbox.label') }}
                .checkbox__description {{ $t('service-request.labels.checkbox.description') }}
          template(v-else) <!--if choose ukraine-->
            h2.form__text.form__title {{ $t('service-request.requireUcraine.title') }}
            .form__text-row
              .form__text-row_1
                h3.form__text.form__text_bold {{ $t('service-request.requireUcraine.post') }}
                address.form__text.form__text_gray.form__address {{ $t('service-request.requireUcraine.address') }}
              .form__text-row_2
                span.form__price.form__text.form__text_gray {{ $t('service-request.requireUcraine.price') }}
          footer.form__footer
            a.link-back(@click="$router.go(-1)") {{ $t('service-request.buttons.back') }}
            input.button.form__submit(type="submit" :value="getValue" :disabled="idDisabled")
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Change_Where-to-get',
  validations: {
    street: {
      required
    },
    home: {
      required
    }
  },
  methods: {
    submitForm () {
      this.$store.dispatch('changeWhereToGet')
    }
  },
  computed: {
    region: {
      get () {
        return this.$store.getters.getWhereToGetRegion
      },
      set (value) {
        this.$store.commit('updateWhereToGetRegion', value)
      }
    },
    delivery: {
      get () {
        return this.$store.getters.getWhereToGetDelivery
      },
      set (value) {
        this.$store.commit('updateWhereToGetDelivery', value)
      }
    },
    street: {
      get () {
        return this.$store.getters.getWhereToGetStreet
      },
      set (value) {
        this.$store.commit('updateWhereToGetStreet', value)
      }
    },
    home: {
      get () {
        return this.$store.getters.getWhereToGetHome
      },
      set (value) {
        this.$store.commit('updateWhereToGetHome', value)
      }
    },
    room: {
      get () {
        return this.$store.getters.getWhereToGetRoom
      },
      set (value) {
        this.$store.commit('updateWhereToGetRoom', value)
      }
    },
    idDisabled () {
      return this.region === 'ukraine' ? false : this.$v.$invalid
    },
    getValue () {
      return this.$t('changeWhereToGet.button')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Change_Where-to-get.vue